import type { Persona } from '@/personas/types';

/**
 * Ren regel för om skapa-flödet ska visas i BARN-presentation (barn-copy +
 * kompanjon som läser wizard-stegen). Persona-styrt och begränsat till 'child';
 * teen och adult får default-presentationen.
 *
 *   - Handledarläge: KLIENTENS persona avgör (handledaren själv resolvar 'adult').
 *     Okänd/saknad klientpersona → false (aldrig defaulta till barn).
 *   - Egen vy: brukarens egen persona avgör.
 *
 * Ren funktion (inga hooks/sidoeffekter) — testbar likt resolveActiveProfile.
 */
export const resolveChildPresentation = (args: {
  isSupervising: boolean;
  ownPersona: Persona;
  clientPersona: Persona | null;
}): boolean => (args.isSupervising ? args.clientPersona === 'child' : args.ownPersona === 'child');
